import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./BlogSolarSection.css";

const BlogSolarSection = () => {

  const navigate = useNavigate();

  const [blogs, setBlogs] = useState([]);

  useEffect(() => {

    const fetchBlogs = async () => {

      try {

        const response = await fetch(
          `${import.meta.env.VITE_API_URL}/blogs`
        );

        const result = await response.json();

        console.log(result);

        setBlogs(result.data);

      } catch (error) {

        console.log("Fetch Error:", error);

      }

    };

    fetchBlogs();

  }, []);

  const handleBlogClick = (blog) => {

    navigate(`/blog/${blog.slug}`);

  };

  return (

    <section className="blogsolar-section">

      <div className="blogsolar-container">

        <h2 className="blogsolar-heading">
          Going Solar Made Easy: <br />
          Everything You Need to Know
        </h2>

        <div className="blogsolar-grid">

          {blogs.map((blog) => (

            <div
              className="blogsolar-card"
              key={blog.id}
              onClick={() => handleBlogClick(blog)}
            >

              <img
                src={
                  blog.image
                    ? `${import.meta.env.VITE_IMAGE_URL}${blog.image}`
                    : "/fallback-image.png"
                }
                alt={blog.title}
                className="blogsolar-image"
              />

              <div className="blogsolar-meta">

                <span>{blog.author}</span>

                <span>{blog.date}</span>

              </div>

              <h3>{blog.title}</h3>

              <p>{blog.description}</p>

            </div>

          ))}

        </div>

      </div>

    </section>

  );
};

export default BlogSolarSection;